import React from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';
import { useFilters } from '../../Provider';
import { CDateRangePicker } from '@web-kc/shared/ui';

const LotDates: React.FC = () => {
  const { t } = useTranslation('tenders');
  const { selectedFilters, setField } = useFilters();

  return (
    <Stack
      direction={{ lg: 'row', md: 'column', xs: 'column' }}
      mt={3.75}
      gap={{ xs: 1.25, lg: 2.5 }}
    >
      <Typography width="100%" maxWidth={120} fontWeight={700}>
        {t('tenders.modal.dates')}
      </Typography>

      <Grid container spacing={3} flexGrow={1}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography>{t('tenders.modal.startTrades')}</Typography>
          <CDateRangePicker
            value={{
              startDate: selectedFilters.startedAfter,
              endDate: selectedFilters.startedBefore,
            }}
            onChange={({ startDate, endDate }) => {
              setField('startedAfter', startDate ?? undefined);
              setField('startedBefore', endDate ?? undefined);
            }}
            sx={{ mt: 1 }}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography>{t('tenders.modal.expiredTrades')}</Typography>
          <CDateRangePicker
            value={{
              startDate: selectedFilters.expiredAfter,
              endDate: selectedFilters.expiredBefore,
            }}
            onChange={({ startDate, endDate }) => {
              setField('expiredAfter', startDate ?? undefined);
              setField('expiredBefore', endDate ?? undefined);
            }}
            sx={{ mt: 1 }}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 4 }}>
          <Typography>{t('tenders.modal.committedTrades')}</Typography>
          <CDateRangePicker
            value={{
              startDate: selectedFilters.committedAfter,
              endDate: selectedFilters.committedBefore,
            }}
            onChange={({ startDate, endDate }) => {
              setField('committedAfter', startDate ?? undefined);
              setField('committedBefore', endDate ?? undefined);
            }}
            sx={{ mt: 1 }}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default LotDates;
